import {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import classNames from 'classnames'
import * as React from 'react'

import {getAgentHref} from '../../../../../routes'
import {getCanViewAgentDetails} from '../../../../../selectors'
import {noop} from '../../../../../utils/empty'
import AgentLink from '../../../../common/AgentLink/AgentLink'
import type {AgentsTreeAgentNode} from '../../AgentsSidebar/AgentsSidebar.types'
import EnableToggle from '../EnableAgentForm/EnableToggle/EnableToggle'

import DisconnectionComment from './DisconnectionComment/DisconnectionComment'

import styles from './AgentListView.css'

import {useAppSelector} from 'src/hooks/react-redux'

// The purpose of this component is to render a placeholder based on agent preview data
// until the full data has been loaded.
function AgentPlaceholderListView({
  className,
  ...agentNode
}: AgentsTreeAgentNode & {
  className?: string
}) {
  const {id, connected, name, osType, enabled, busy} = agentNode

  return (
    <div className={classNames(className, styles.agent, styles.loading)}>
      {connected ? ( // This is a fake toggle that does nothing.
        <EnableToggle
          className={classNames(styles.toggle, styles.loadingToggle)}
          isToggleable={false}
          enabled={enabled}
          handleToggleClick={noop}
          title="Loading agent data..."
          size={Size.Size20}
          pale={false}
        />
      ) : null}
      <AgentLink
        isSakuraUI
        name={name}
        className={styles.link}
        {...(useAppSelector(getCanViewAgentDetails)
          ? {
              href: getAgentHref(id),
              agentId: id,
              osType,
            }
          : {})}
      />
      {connected && !busy && <div className={styles.idle}>{'Idle'}</div>}
      {!connected && <DisconnectionComment className={styles.disconnectionComment} />}
      <div className={styles.split} />
    </div>
  )
}

export default AgentPlaceholderListView
